'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

var _utils2 = require('../../../core/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Selection for extra services.
var WinresReservationExtraServicesController = function () {
    function WinresReservationExtraServicesController($scope, productService, reservationService, localizationService, customerService, $location, $rootScope, $timeout) {
        _classCallCheck(this, WinresReservationExtraServicesController);

        this.$scope = $scope;
        this.productService = productService;
        this.customerService = customerService;
        this.$location = $location;
        this.$timeout = $timeout;
        this.reservationService = reservationService;
        this.localizationService = localizationService;
        $scope.Math = Math;
        this.data = { ExtraServices: null };
        this.allowedAmount = [];
        this.$rootScope = $rootScope;
        this.busStopsToThere = [];
        this.busStopsFromThere = [];
        this.busStopsBothWays = [];
        this.busStopsToThereAndBack = [];
        this.showPriceOfBusTrip = [];
        this.animatePrice = [];
        this.busTripPrice = [];
        this.busTripPriceVatZero = 0;
        this.routes = [];
        this.busGroups = {};
        this.busStopForced = false;
        this.productLines = [];
        this.busProduct = {};
        this.tripSelector = [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []];
        this.forcedProducts = [];
    }

    _createClass(WinresReservationExtraServicesController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            if (!this.winresReservationContext) {
                if (window.definiteWinresReservationContext) {
                    console.log('[winres-reservation-extra-services]', 'Context is not available. Falling back to global.');
                    this.winresReservationContext = window.definiteWinresReservationContext;
                } else {
                    throw new Error('A context is required.');
                }
            }

            // This is called when "Muokkaa lisäpalveluja" is clicked.

            if (!this.hideBusses) {
                this.$scope.$watch('$ctrl.winresReservationContext.getCurrentPhase()', function (response) {
                    console.log("[WRES] getCurrentPhase: ", response);
                    if (response != undefined && response === 'extraservices') {
                        // Select dropdown bus.
                        _this.setDefaultOptions();
                    }
                });
            }

            // This is called during first load.
            this.$scope.$watch('$ctrl.routes', function (response) {
                console.log("bus routes watch fired! $ctrl.routes was: ", JSON.parse(JSON.stringify(response)));
                if (_this.hasSessionBusses) {
                    console.log("hasSessionBusses! Busses taken from session.");
                    return; // Busses taken from session.
                }
                if (!response) return; // Routes must exist.
                if (response.length <= 0) return;

                // Reset busses.
                _this.resetBusses();

                if (response.length > 0) {
                    response.forEach(function (elem, ind) {
                        var route = _this.getFromToFromBusStops(elem);
                        elem.name = route[0];
                        elem.label = route[0];
                        elem.id = ind;
                    });
                    try {
                        _this.splitToBusTripGroups(response).then(function (groups) {
                            _this.busGroups = groups[0];
                            _this.updateBusSession("busGroups", _this.busGroups);
                            _this.tripSelectorAtStart();
                            var tempArr = ['both', 'go', 'return'];
                            _this.$rootScope.loadingBusses = true;
                            tempArr.forEach(function (elem, ind) {
                                console.log("foreach.. this.busGroups[" + elem + "]", _this.busGroups[elem]);
                                var tempBusStopArr = [];
                                if (_this.busGroups[elem].length > 0) {
                                    tempBusStopArr = _this.busGroups[elem][0].BusStops;
                                    _this.setBusses(tempBusStopArr, elem, tempArr.length);
                                }
                            });
                        });
                    } catch (err) {
                        console.error("[WRES] something went wrong when watching bus routes: ", err);
                        _this.$rootScope.busError = true; // Show error icon.
                    }
                }
            });

            if (this.source == 'omaloma') {
                this.$scope.$watch('$ctrl.winresReservationContext.context.selectedReservation', function () {
                    if (!_this.winresReservationContext.context.selectedReservation) {
                        return;
                    }
                    _this.winresReservationContext.getSelectedReservationExtraServices();
                    _this.data = _this.winresReservationContext.context.selectedReservation;
                });
                this.$scope.$watchCollection('$ctrl.winresReservationContext.context.selectedReservation.ExtraServices', function () {
                    _.each(_this.winresReservationContext.context.selectedReservation.ExtraServices, function (p) {
                        _.each(p, function (product) {
                            if (!product.Amount) {
                                product.Amount = 0;
                            }
                        });
                    });
                });
                this.$scope.$watch('$ctrl.data.data', function (data) {
                    if (!data) return;
                    _this.allowedAmount = [];
                    var numPassengers = _this.data.data.BookInfos.Childs + _this.data.data.BookInfos.Adults + _this.data.data.BookInfos.Infants;
                    for (var i = 0; i <= numPassengers; i++) {
                        _this.allowedAmount.push(i);
                    }
                });
            }

            // Dependencies
            // this.winresReservationContext

            // Get:
            // getContext()
            // getContext().SelectedDeparture
            // getContext().DefaultEndDate
            // getContext().DefaultStartDate
            // getContext().Passengers
            // getContext().Products
            // getContext().NumAdults
            // getContext().NumChildren
            // getContext().NumInfants
            // getContext().data
            // context.selectedReservation
            // context.selectedReservation.data.data
            // context.Products
            // getSelectedReservationExtraServices()
            // getSeoState()
            // findProductLineByProduct()
            // getPassengerDisplayNames()

            // Set:
            // getContext().SelectedDeparture
            // getContext().Products
            // setReservationComponentErrors()

            // Other:
            // calculateTotalPrice()
            // addExtraServiceToPassenger

            this.data = this.winresReservationContext.getContext();

            this.useSeo = this.winresReservationContext.getSeoState();

            this.$scope.$on('number-of-people-change', function () {
                _this.getExtraServices();
                if (!_this.hideBusses) _this.getBusRoutes();
            });

            //this list is for joiku/minisite, those uses it to display dropdown between 1 and 10
            this.dropdownValues = { '1': 1, '2': 2, '3': 3, '4': 4, '5': 5, '6': 6, '7': 7, '8': 8, '9': 9, '10': 10 };

            // Departure is based on the departure selected from previous steps.
            // If the departure changes, clear extra services from the
            // shopping cart since they are no longer valid.
            // (TODO: It is possible to search for the services with the new
            //  departure.)


            // When departure changes, fetch service products.
            var onDepartureChange = function onDepartureChange() {
                if (_this.data.SelectedDeparture) {
                    _this.getExtraServices();

                    if (_this.hideBusses) return;

                    // Set productLines and busProduct to session if exist.
                    _this.$scope.$watch("$ctrl.productLines", function () {
                        return _this.updateBusSession("productLines", _this.productLines);
                    });
                    _this.$scope.$watch("$ctrl.busProduct", function () {
                        return _this.updateBusSession("busProduct", _this.busProduct);
                    });

                    _this.hasSessionBusses = _this.data.BusSession && _this.data.BusSession.productLines && _this.data.BusSession.productLines.length > 0 && _this.data.BusSession.productLines[0] && _this.data.BusSession.productLines[0].DestinationCode == _this.data.DestinationCode // Reset bus session if destination changes.
                    && _this.data.BusSession.numOfPeople == _this.data.NumAdults + _this.data.NumChildren // Reset bus session if number of people changes.
                    && _this.data.BusSession.productLines[0].BeginDate == moment(_this.data.SelectedDeparture.DepartureDate).format("YYYY-MM-DD") && _this.data.BusSession.productLines[0].EndDate == moment(_this.data.SelectedDeparture.ArrivalDate2).format("YYYY-MM-DD");

                    _this.updateBusSession("numOfPeople", _this.data.NumAdults + _this.data.NumChildren);

                    // Get busses from session.
                    if (_this.hasSessionBusses) {
                        _this.resetBusses();
                        _this.$scope.firstBusses = true; // Enable bus dropdown.
                        //this.$rootScope.loadingBusses = false; // Enable bus dropdown.

                        // Copy this.data.BusSession to controller.
                        for (var key in _this.data.BusSession) {
                            _this[key] = _this.data.BusSession[key];
                        }

                        // Push bus products to this.data.Products.
                        _.each(_this.productLines, function (productLine) {
                            return _this.data.Products.push(productLine);
                        });

                        return;
                    }

                    // Busses
                    _this.getBusRoutes();
                }
            };

            if (this.fromUrl === "true") {
                this.data.SelectedDeparture = {};
                this.data.SelectedDeparture.DepartureDate = (0, _utils.readUrlPart)(this.$location, this.useSeo ? 2 : 1);
                this.data.SelectedDeparture.ArrivalDate2 = (0, _utils.readUrlPart)(this.$location, this.useSeo ? 3 : 2);
                this.DefaultStartDate = this.data.DefaultStartDate;
                this.DefaultEndDate = this.data.DefaultEndDate;
                this.$scope.$watch(function () {
                    return _this.data;
                }, function () {
                    if (_this.data.DefaultEndDate != _this.DefaultEndDate || _this.data.DefaultStartDate != _this.DefaultStartDate) {

                        _this.DefaultStartDate = _this.data.DefaultStartDate;
                        _this.DefaultEndDate = _this.data.DefaultEndDate;
                        _this.extraServiceDateChange();
                    }
                }, true);
                onDepartureChange();
            } else {
                this.$scope.$watch('$ctrl.data.SelectedDeparture', onDepartureChange);
            }

            this.$scope.$watch('$ctrl.data.Passengers', function () {
                return _this.updatePassengerData();
            }, true);

            this.$scope.$on('accommodationAddedToCart', function () {
                console.log("[WRES] Broadcast received: Accommondation added to cart");
                //this.checkForForcedProducts();
            });
            this.$scope.$watchGroup(['$ctrl.data.NumAdults', '$ctrl.data.NumChildren', '$ctrl.data.NumInfants'], function () {
                _this.updateNonGroupForcings();
                _this.updatePassengerData();
            });

            /*this.$scope.$watch('$ctrl.data.DestinationCode', () => {
                this.productService.getBusRoutesByDestinationCode(this.data.DestinationCode).then((response) => {
                    if(response.Message === 'Success') {
                        this.routes = response.Routes;
                    } else {
                        console.log("======================================");
                        console.log("Routes Fetch failed");
                        console.log("======================================");
                    }
                });
            });*/
            // Translations become available, i.e. Passenger #1 texts can be
            // displayed.
            this.$scope.$on('i18nextLanguageChange', function () {
                return _this.updatePassengerNames();
            });

            if (this.assignPassengers != 'false') {
                $('body').click(function (e) {
                    _this.$scope.$applyAsync(function () {
                        var target = $(e.target);
                        if (target.is('.passenger-assignment, .assign-passengers') || target.parents('.passenger-assignment, .assign-passengers').length != 0) {
                            return;
                        } else {
                            _.each(_this.data.ProductGroups, function (group) {
                                _.each(group.Products, function (product) {
                                    product.AssignmentVisible = false;
                                });
                            });
                        }
                    });
                });
            }
        }
    }, {
        key: 'getBusRoutes',
        value: function getBusRoutes() {
            var _this2 = this;

            var destinationCode = this.data.SelectedDeparture.DestinationCode;
            this.productService.getBusRoutesByDestinationCode(destinationCode).then(function (response) {
                if (response.Message === 'Success') {
                    if (response.Routes.length > 0) {
                        // if(response.Routes[0] && this.isValidDestinationCode(undefined, response.Routes[0].DestinationCode)){
                        // Here we check which off the all bus routes actually are reservable
                        // (Would of course be nice if the GetBusRoutes would have an option
                        // to only return reservable routes. Or that this component would be
                        // structured better)
                        console.log("Received unfiltered bus routes: ", response);
                        _this2.filterReservableBusRoutes(response.Routes).then(function (reservableRoutes) {
                            if (!reservableRoutes || reservableRoutes.length === 0) {
                                console.warn("No reservable bus routes! It seems routes were received, but filtered out when comparing to reservable bus products.");
                            }
                            _this2.routes = reservableRoutes;
                            console.log("Reservable bus routes after comparing to reservable bus products and filteing: ", reservableRoutes);
                            _this2.updateBusSession("routes", _this2.routes);
                        });
                    } else if (response.Routes[0] && response.Routes[0].length == 0) {
                        console.warn("[WRES] onDepartureChange: no routes");
                    } else if (response.Routes[0]) {
                        console.warn("[WRES] onDepartureChange: response.Routes[0] DestinationCode differs from SelectedDeparture DestinationCode", _this2.data.SelectedDeparture.DestinationCode, response.Routes[0].DestinationCode);
                    }
                    //} else {
                    //    console.error("[WRES] onDepartureChange: response.Routes[0] is", response.Routes[0]);
                    //    this.$rootScope.busError = true;
                    //}
                } else {
                    console.error("Routes Fetch failed");
                    _this2.$rootScope.busError = true;
                }
            });
        }
    }, {
        key: 'getExtraServices',
        value: function getExtraServices() {
            var _this3 = this;

            var groups = _.filter(_.map(_.split(this.groups, ','), _.trim), function (s) {
                return s !== '';
            });

            if (groups.length == 0) {
                groups = null;
            }
            this.reservableBusProducts = this.getReservableBusProducts();
            // Fetch extra services available on that departure
            // (grouped by their linking group set in LinkingInfo)
            this.productService.getReservableProductsGrouped({
                DestinationCode: this.useSelectedDeparture == 'true' ? this.data.SelectedDeparture.DestinationCode : this.forceDestCode != null ? this.forceDestCode : this.data.DestinationCode,
                StartDate: this.forceDestCode != null || this.useSelectedDeparture === 'true' ? null : this.data.SelectedDeparture.DepartureDate || this.data.DefaultStartDate,
                EndDate: this.forceDestCode != null || this.useSelectedDeparture === 'true' ? null : this.data.SelectedDeparture.ArrivalDate2 || this.data.DefaultEndDate,
                MinCapacity: 1,
                GroupIDs: groups,
                ProductType: 'common'
            }, this.localizationService.getLanguage()).then(function (productGroups) {
                //    if(productGroups[0] && !this.isValidDestinationCode(productGroups[0][0])){
                //         console.warn("[WRES] onDepartureChange: productGroups[0][0] DestinationCode differs from SelectedDeparture DestinationCode",
                //         this.data.SelectedDeparture.DestinationCode, productGroups[0][0].DestinationInfo.DestinationCode);
                //         return;
                //     }
                /*_.each(this.data.Products, product=>{
                    product.PriceSelections = [];
                })*/
                _this3.priceSelectionIds = 1; // Reset price selection id.
                _this3.productsEdit(productGroups);
            });
        }
    }, {
        key: 'updateBusSession',
        value: function updateBusSession(key, value) {
            if (!this.data.BusSession) this.data.BusSession = {};
            this.data.BusSession[key] = value;
        }
    }, {
        key: 'resetBusses',
        value: function resetBusses() {
            // Loading bus indicator.
            this.busLoading = 0;

            // Exist to stop changing select input busses during first load.
            // Is set false if at least one bus is loaded.
            this.$scope.firstBusses = false;
            this.$rootScope.busError = false; // Hide error icon.
            this.canSetForcedBusses = true; // Can set forced busses.
            this.productLines = []; // Clear product lines.
            this.busProduct = null; // Clear bus product.
        }
    }, {
        key: 'isValidDestinationCode',
        value: function isValidDestinationCode(departure, destinationCode) {
            if (destinationCode && destinationCode != this.data.SelectedDeparture.DestinationCode) {
                return false;
            }
            if (departure && departure.DestinationInfo && departure.DestinationInfo.DestinationCode != this.data.SelectedDeparture.DestinationCode) {
                return false;
            }
            return true;
        }
    }, {
        key: 'pickFirstValue',
        value: function pickFirstValue(busElement) {
            for (var i = 0; i < busElement.length; i++) {
                if (busElement[i].className == "ng-binding" || busElement[i].value == "?") continue;
                return busElement[i].value;
            }
            return "";
        }
    }, {
        key: 'selectBusByProductName',
        value: function selectBusByProductName(busElement, productLine) {
            for (var i = 0; i < busElement.length; i++) {
                var productName = productLine.Product.DestinationInfo.ProductName.replace(/ /g, "");
                var name = productName.split("-")[1];
                var label = busElement[i].label.replace(/ /g, "");
                if (label.indexOf(name) > -1) {
                    busElement.selectedIndex = busElement[i].index;
                    busElement.value = busElement[i].value;
                }
            }
        }
    }, {
        key: 'setDefaultOptions',
        value: function setDefaultOptions(idx) {
            var _this4 = this;

            setTimeout(function () {
                var busStopToBothWays = document.querySelectorAll('select.busStopToBothWays');
                var busStopToThere = document.querySelectorAll('select.busStopToThere');
                var busStopFromThere = document.querySelectorAll('select.busStopFromThere');

                // Select bus by idx.
                if (idx != null) {
                    if (busStopToBothWays[idx]) busStopToBothWays[idx].value = _this4.pickFirstValue(busStopToBothWays[idx]);
                    if (busStopToThere[idx]) busStopToThere[idx].value = _this4.pickFirstValue(busStopToThere[idx]);
                    if (busStopFromThere[idx]) busStopFromThere[idx].value = _this4.pickFirstValue(busStopFromThere[idx]);
                    return;
                }

                // Select first bus.
                if (_this4.busStopForced) {
                    var i = 0;
                    for (i = 0; i < busStopToBothWays.length; i++) {
                        busStopToBothWays[i].value = _this4.pickFirstValue(busStopToBothWays[i]);
                    };
                    for (i = 0; i < busStopToThere.length; i++) {
                        busStopToThere[i].value = _this4.pickFirstValue(busStopToThere[i]);
                    };
                    for (i = 0; i < busStopFromThere.length; i++) {
                        busStopFromThere[i].value = _this4.pickFirstValue(busStopFromThere[i]);
                    };
                }

                // Select busses by tab bus name.
                _.each(_this4.productLines, function (productLine) {
                    var id = idx;

                    if (id == null) id = productLine.PassengerId;

                    if (busStopToBothWays.length) _this4.selectBusByProductName(busStopToBothWays[id], productLine);
                    if (busStopToThere.length) _this4.selectBusByProductName(busStopToThere[id], productLine);
                    if (busStopFromThere.length) _this4.selectBusByProductName(busStopFromThere[id], productLine);
                });
                if (_this4.hasSessionBusses) _this4.loadingBusses = false;
            }, 50);
        }

        // Copy/paste of convertBusStops without promises.

    }, {
        key: 'setBusses',
        value: function setBusses(busStopsArr, type) {
            var _this5 = this;

            var iterations = busStopsArr.length;
            var i = 0;
            if (this.data.SelectedDeparture !== null) {
                var searchCriteria = {
                    DestinationCode: this.busGroups[type][0].DestinationCode.replace(/ /g, ""),
                    ProductCode: this.busGroups[type][0].ProductCode.replace(/ /g, ""),
                    StartDate: this.data.SelectedDeparture.DepartureDate,
                    EndDate: this.data.SelectedDeparture.ArrivalDate2,
                    PriceGroup: busStopsArr[0].PriceGroup
                    //PriceGroup: elem.PriceGroup
                };
                this.productService.getReservableProducts(searchCriteria, this.localizationService.getLanguage()).then(function (response) {
                    if (response.length === 0) {
                        console.error("[WRES] setBusses: getReservableProducts call is empty");
                        _this5.$rootScope.busError = true;
                    } else {
                        // if(!this.isValidDestinationCode(response[0])){
                        //     console.error("[WRES] setBusses: response[0] DestinationCode differs from SelectedDeparture DestinationCode",
                        //     this.data.SelectedDeparture.DestinationCode, response[0].DestinationInfo.DestinationCode);
                        //     return;
                        // }

                        if (response[0].LinkingInfo === null) {
                            _this5.busProduct = response[1];
                        } else {
                            _this5.busProduct = response[0];
                        }

                        try {
                            if (_this5.busProduct.LinkingInfo.ForcingMode === "Forced" && _this5.busProduct.DestinationInfo.ProductType === 'BU') {
                                _this5.busStopForced = true;
                            }
                        } catch (err) {
                            console.error("[WRES] Bus error, setBusses:", err);
                            _this5.$rootScope.busError = true;
                        }

                        // This sets bus labels.
                        _.each(busStopsArr, function (elem) {
                            elem.id = elem.Id;
                            response.forEach(function (pElem) {
                                if (pElem.ReservablePrices != null && pElem.ReservablePrices.length > 0) {
                                    //
                                    pElem.ReservablePrices.forEach(function (priceElem, priceInd) {
                                        if (parseInt(elem.K1PriceIndex, 10) === parseInt(priceElem.Index, 10)) {
                                            elem.realPrice = priceElem.Price;
                                            elem.name = elem.Name + ' | Pysäkillä: [ ' + elem.Time + ' ]' + ' | Hinta: [ ' + elem.realPrice + '€ ]';
                                            elem.label = elem.Name;
                                        }
                                    });
                                } else {
                                    console.error("[WRES] setBusses: ReservablePrices is empty");
                                    elem.name = elem.Name;
                                    elem.label = elem.Name;
                                }
                            });
                        });

                        _this5.setPassengersBusses(busStopsArr, type);

                        //this.data.BusSession.busses = [];
                        //this.data.BusSession.busses.push({type: type, busStopsArr: busStopsArr});
                    }
                });
            } else {
                console.error("[WRES] setBusses: selectedDeparture is", this.data.SelectedDeparture);
                this.$rootScope.busError = true;
            }
        }
    }, {
        key: 'setPassengersBusses',
        value: function setPassengersBusses(busStopsArr, type) {
            var _this6 = this;

            var iterations = this.data.Passengers.length;
            var i = 0;

            // This creates bus dropdown list.
            this.data.Passengers.forEach(function (passengerElem, ind) {
                switch (type) {
                    case 'both':
                        _this6.busStopsBothWays[ind] = busStopsArr;
                        break;
                    case 'go':
                        _this6.busStopsToThere[ind] = busStopsArr;
                        break;
                    case 'return':
                        _this6.busStopsFromThere[ind] = busStopsArr;
                        break;
                }

                // Set forced busses after setting last passenger select input busses.
                i++;
                if (i >= iterations) {
                    if (_this6.busStopForced) _this6.setForcedBusses(); // This sets busses to tab.
                    else {
                            _this6.$scope.firstBusses = true; // Can change busses if not forced.
                            _this6.$rootScope.loadingBusses = false;
                        }

                    _this6.updateBusSession("busStopsBothWays", _this6.busStopsBothWays);
                    _this6.updateBusSession("busStopsToThere", _this6.busStopsToThere);
                    _this6.updateBusSession("busStopsFromThere", _this6.busStopsFromThere);
                }
            });
        }
    }, {
        key: 'setForcedBusses',
        value: function setForcedBusses() {
            var _this7 = this;

            if (!this.canSetForcedBusses) return;
            this.canSetForcedBusses = false;

            //console.log(this.data);
            this.data.Passengers.forEach(function (elem, ind) {
                var tempArr = ['go', 'return', 'both'];
                tempArr.forEach(function (telem, tind) {
                    if (_this7.busGroups[telem].length > 0) {
                        _this7.$rootScope.loadingBusses = false;
                        switch (telem) {
                            case 'both':
                                var busStopToBothWays = _this7.busStopsBothWays[ind][0];
                                if (!busStopToBothWays || !busStopToBothWays.label) _this7.$rootScope.busError = true;
                                if (!busStopToBothWays) console.error("[WRES] busStopToBothWays is", busStopToBothWays);
                                if (busStopToBothWays && !busStopToBothWays.label) console.error("[WRES] busStopToBothWays.label is", null);
                                _this7.chooseStopToThereAndBack(busStopToBothWays.label, ind, 'both');
                                break;
                            case 'return':
                                var busStopFromThere = _this7.busStopFromThere[ind][0];
                                if (!busStopFromThere || !busStopFromThere.label) _this7.$rootScope.busError = true;
                                if (!busStopFromThere) console.error("[WRES] busStopFromThere is", busStopFromThere);
                                if (busStopFromThere && !busStopFromThere.label) console.error("[WRES] busStopFromThere.label is", null);
                                _this7.chooseStopToThereAndBack(busStopFromThere.label, ind, 'return');
                                break;
                            case 'go':
                                var busStopToThere = _this7.busStopToThere[ind][0];
                                if (!busStopToThere || !busStopToThere.label) _this7.$rootScope.busError = true;
                                if (!busStopToThere) console.error("[WRES] busStopToThere is", busStopToThere);
                                if (busStopToThere && !busStopToThere.label) console.error("[WRES] busStopToThere.label is", null);
                                _this7.chooseStopToThereAndBack(busStopToThere.label, ind, 'go');
                                break;
                        }
                    }
                });
            });
        }
    }, {
        key: 'removeBusStopFromProductLines',
        value: function removeBusStopFromProductLines(passengerId, busGroup) {
            var productCode = '';
            var destinationCode = '';
            this.routes.forEach(function (elem, ind) {
                if (busGroup === elem.Direction) {
                    productCode = elem.ProductCode.replace(/ /g, "");
                    destinationCode = elem.DestinationCode.replace(/ /g, "");
                }
            });
            var tempObj = {};
            var tempVar = -1;
            this.productLines.some(function (elem, ind) {
                if (elem.PassengerId === passengerId && elem.ProductCode === productCode && elem.DestinationCode === destinationCode) {
                    tempObj = elem;
                    tempVar = ind;
                    return true;
                }
            });

            if (!_.isEmpty(tempObj)) {
                var tempVal = [];

                tempObj.PassengerAssignments.forEach(function (elem, ind) {
                    if (elem.PassengerNumber === passengerId) {
                        tempVal.push(ind);
                    }
                });
                if (tempVal.length > 0) {
                    tempObj.PassengerAssignments.splice(tempVal[0], 1);
                }
                if (tempObj.PassengerAssignments.length === 0) {
                    this.productLines.splice(tempVar, 1);
                    this.data.Products.splice(tempVar, 1);
                }
                this.animatePrice[0][passengerId][busGroup] = false;
                this.showPriceOfBusTrip[0][passengerId][busGroup] = false;
            }
        }
    }, {
        key: 'tripSelectorAtStart',
        value: function tripSelectorAtStart() {
            for (var i = 0; i < this.tripSelector.length; i++) {
                if (this.busGroups.both.length > 0) {
                    this.tripSelector[i].push(1);

                    if (this.busGroups.go.length > 0) {
                        this.tripSelector[i].push(1);
                    } else {
                        if (this.busGroups.return.length > 0) {
                            this.tripSelector[i].push(1);
                            this.tripSelector[i].push(1);
                        }
                    }
                } else {
                    if (this.busGroups.go.length > 0) {
                        this.tripSelector[i].push(1);
                        this.tripSelector[i].push(1);
                    } else {
                        if (this.busGroups.return.length > 0) {
                            this.tripSelector[i].push(1);
                            this.tripSelector[i].push(1);
                            this.tripSelector[i].push(1);
                        }
                    }
                }
            }
        }
    }, {
        key: 'busTripSelector',
        value: function busTripSelector(passengerId, column) {
            this.tripSelector[passengerId] = [];
            for (var i = 0; i < column; i++) {
                this.tripSelector[passengerId].push(i);
            }
        }
    }, {
        key: 'splitToBusTripGroups',
        value: function splitToBusTripGroups(routes) {
            var tempObj = {
                go: [],
                return: [],
                both: []
            };
            /* MOCK */
            // routes.push(_.clone(routes[0]));
            // routes.push(_.clone(routes[0]));
            /* MOCK */
            routes.forEach(function (elem, ind) {
                /* MOCK */
                /*
                if(ind === 1) {
                    elem.Direction = 'go';
                }
                if(ind === 2) {
                    elem.Direction = 'return';
                }
                */
                /* MOCK */
                switch (elem.Direction) {
                    case 'go':
                        tempObj.go.push(elem);
                        break;
                    case 'return':
                        tempObj.return.push(elem);
                        break;
                    case 'both':
                        tempObj.both.push(elem);
                        break;
                    default:
                        console.log("Unknown direction type: " + elem.Direction);
                        break;
                }
            });
            return Promise.all([tempObj]);
        }
    }, {
        key: 'getFromToFromBusStops',
        value: function getFromToFromBusStops(route) {
            var fromStr = route.BusStops[0].Name.split(',')[0];
            var toStr = route.BusStops[route.BusStops.length - 1].Name.split(',')[0];
            return [fromStr + ' - ' + toStr];
        }
    }, {
        key: 'updatePricesByPassengAssignments',
        value: function updatePricesByPassengAssignments(passengerId, busStopId, busGroup, priceOfTrip) {
            var _this8 = this;

            // Calculate per-passenger prices (backend handles this.)
            // Make a product line for each product / passenger -combo
            // (for extra services, the whole product row price is the sum of all
            //  individual passengers' prices. This does not hold for
            //  accommodations.)

            var firstProduct = this.data.Products[0];
            if (!firstProduct) console.warn("[WRES] updatePricesByPassengAssignments: this.data.Products[0] is null, productLine BeginDate and EndDate may differ. passengerId: ", passengerId);

            this.checkProductLinesFromByPassengerId(passengerId).then(function (response) {
                // Clone the busProduct to allow multiple types of products on call.
                var tempBusProduct = JSON.parse(JSON.stringify(_this8.busProduct));

                // Fix the bus product EndDate since it's the same as BeginDate.
                if (firstProduct) {
                    tempBusProduct.BeginDate = firstProduct.Product.BeginDate;
                    tempBusProduct.EndDate = firstProduct.Product.EndDate;
                }

                _this8.routes.forEach(function (elem, ind) {
                    // Added the condition _.some(elem.BusStops, ['Id', busStopId]
                    // Because in a case when there where multiple busses linked and some buss was
                    // linked from another product and both had Direction of the routes set to same (ex. "both")
                    // this function could by mistake write wrong destinationCode and productCode while keeping
                    // the original busStopId. Added a check for that the selected route have to contain
                    // the busStopId, but still not sure that it contains all the cases
                    if (busGroup === elem.Direction && _.some(elem.BusStops, ['Id', busStopId])) {
                        tempBusProduct.DestinationInfo.DestinationCode = elem.DestinationCode.replace(/ /g, "");
                        tempBusProduct.DestinationInfo.ProductCode = elem.ProductCode.replace(/ /g, "");
                    }
                });

                var beginDate = "";
                var endDate = "";

                if (!firstProduct) {
                    beginDate = tempBusProduct.BeginDate;
                    endDate = tempBusProduct.EndDate;
                }

                if (firstProduct) {
                    switch (busGroup) {
                        case 'both':
                            beginDate = firstProduct.Product.BeginDate;
                            endDate = firstProduct.Product.EndDate;
                            break;
                        case 'go':
                            beginDate = firstProduct.Product.BeginDate;
                            endDate = firstProduct.Product.BeginDate;
                            break;
                        case 'return':
                            beginDate = firstProduct.Product.EndDate;
                            endDate = firstProduct.Product.EndDate;
                            break;
                    }
                    tempBusProduct.BeginDate = beginDate;
                    tempBusProduct.EndDate = endDate;
                }

                console.log("Temp bus product: ", tempBusProduct);
                tempBusProduct.BusStops.forEach(function (elem, ind) {
                    if (busStopId === elem.Id) {
                        tempBusProduct.DestinationInfo.ProductName = "Bussikuljetus - " + elem.Name;
                        tempBusProduct.Price = priceOfTrip; //
                    }
                });

                if (firstProduct) console.log("[WRES] Use first product date.");else console.log("[WRES] Use bus product date.");

                var productLine = {
                    Amount: 1,
                    DestinationCode: tempBusProduct.DestinationInfo.DestinationCode,
                    ProductCode: tempBusProduct.DestinationInfo.ProductCode,
                    BeginDate: beginDate,
                    EndDate: endDate,
                    PassengerAssignments: [{
                        PassengerNumber: passengerId,
                        ProductNumber: 1,
                        BusStopID: busStopId,
                        BusGroup: busGroup,
                        PriceOfTrip: priceOfTrip
                    }],
                    PassengerId: passengerId,
                    Product: tempBusProduct,
                    TotalPrice: priceOfTrip //
                };

                // Replace name and price of existing product and prevent duplicates.
                var found = false;

                // Visible products.
                for (var key in _this8.data.Products) {
                    var product = _this8.data.Products[key];
                    if (product.PassengerId != null && product.PassengerId == passengerId) {
                        _this8.data.Products[key] = productLine;
                    }
                }

                // Loading products.
                for (var key in _this8.productLines) {
                    var product = _this8.productLines[key];
                    if (product.PassengerId != null && product.PassengerId == passengerId) {
                        _this8.productLines[key] = productLine;
                        found = true;
                    }
                }

                if (found) {
                    _this8.busLoading--;
                    if (_this8.busLoading <= 0) {
                        _this8.$rootScope.loadingBusses = false;
                    }
                    return;
                }

                // if the passenger doesn't have a product line then add new else replace existing one.
                _this8.productLines.push(productLine);
                console.log("[WRES] added productLine", productLine);

                // Sort busses.
                var nonIdProductLines = [];
                var idProductLines = _.filter(_this8.productLines, function (productLine) {
                    if (productLine.PassengerId != null) return true;
                    nonIdProductLines.push(productLine);
                });
                idProductLines.sort(function (a, b) {
                    return a.PassengerId - b.PassengerId;
                });
                var sortedProductLines = nonIdProductLines; // Sort products without id first.
                sortedProductLines = sortedProductLines.concat(idProductLines);
                _this8.productLines = sortedProductLines;

                //this.productLines = _.sortedIndexBy(this.productLines, productLine)

                _this8.reservationService.calculateProductLinePricesSimple( //
                _this8.productLines, _this8.data.Passengers, _this8.localizationService.getLanguage()).then(function (results) {
                    if (!_this8.firstBusses) _this8.setDefaultOptions(passengerId); // Select first bus in select input.

                    _this8.busLoading--;
                    if (_this8.busLoading <= 0) {
                        _this8.$scope.firstBusses = true; // Can change busses after first load.
                        _this8.$rootScope.loadingBusses = false;
                    }

                    // Show error icon if no results.
                    if (!results) {
                        console.error("[WRES] bus error: calculateProductLinePricesSimple results is", results);
                        _this8.$rootScope.busError = true;
                        return;
                    }

                    var extraServicesProductLines = _this8.getBusProductLines();
                    if (extraServicesProductLines.length <= 0) console.error("[WRES] this.getBusProductLines returned ", extraServicesProductLines);

                    extraServicesProductLines.forEach(function (elem, ind) {
                        // Note: previously var tempRes = results[ind+1]; without ifs.
                        // Note2: Sometimes firstProduct may have data from previous departure,
                        // which results to array with null elements only. result = [null, null, null].
                        // Errors also if no price.
                        var tempRes = results[ind];
                        if (results[ind] == null) tempRes = results[ind + 1];

                        try {
                            elem.Product.Price = '' + tempRes.Price;
                            elem.Product.TaxPros = tempRes.TaxPercent;
                        } catch (err) {
                            console.error("[WRES] bus error ", err, "results is", results);
                            _this8.$rootScope.busError = true;
                        }

                        _this8.checkIfProductExistAllready(_this8.data.Products, elem.PassengerId, elem.PassengerAssignments[0].BusStopID).then(function (response) {
                            elem.PassengerAssignments.forEach(function (pAelem, pAind) {
                                elem.TotalPrice = parseInt(pAelem.PriceOfTrip);
                            });
                            if (!response[0]) {
                                if (elem.PassengerId == passengerId) {
                                    _this8.data.Products.push(elem);
                                }
                            } else {
                                if (response[1] != -1) {
                                    _this8.data.Products[response[1]] = elem;
                                }
                            }
                        });
                    });
                }, function (err) {
                    console.log(err);
                });
            });
        }
    }, {
        key: 'getBusProductLines',
        value: function getBusProductLines() {
            var tempArr = [];
            this.productLines.forEach(function (elem, ind) {
                if (elem.Product.DestinationInfo.ProductType == 'BU') {
                    tempArr.push(_.clone(elem));
                }
            });
            return tempArr;
        }
    }, {
        key: 'checkIfProductExistAllready',
        value: function checkIfProductExistAllready(products, passengerId, busStopID) {
            var tempBool = false;
            var tempNumber = -1;
            products.forEach(function (elem, ind) {
                elem.PassengerAssignments.forEach(function (pElem, pInd) {
                    if (elem.PassengerId === passengerId) {
                        if (pElem.BusStopID === busStopID) {
                            tempBool = true;
                            tempNumber = ind;
                        }
                    } else {
                        if (pElem.BusStopID === busStopID) {
                            tempNumber = ind;
                        }
                    }
                });
            });
            return Promise.all([tempBool, tempNumber]);
        }
    }, {
        key: 'checkProductLinesFromByPassengerId',
        value: function checkProductLinesFromByPassengerId(passengerId) {
            var tempBool = false;
            var index = 0;
            this.productLines.forEach(function (elem, ind) {
                if (elem.PassengerId === passengerId) {
                    tempBool = true;
                    index = ind;
                }
            });
            return Promise.all([tempBool, index]);
        }

        // When ng-change triggers

    }, {
        key: 'busChange',
        value: function busChange(stopLabel, passengerId, busGroup) {
            if (!this.$rootScope.loadingBusses && this.$scope.firstBusses) {
                // Can't change while loading busses.
                console.log("[WRES] NG CHANGE");
                this.chooseStopToThereAndBack(stopLabel, passengerId, busGroup);
            }
        }
    }, {
        key: 'chooseStopToThereAndBack',
        value: function chooseStopToThereAndBack(stopLabel, passengerId, busGroup) {
            var _this9 = this;

            if (stopLabel != null) {
                this.$rootScope.loadingBusses = true;
                this.busLoading++;

                var busStops = [];
                switch (busGroup) {
                    case 'both':
                        busStops = this.busStopsBothWays[passengerId];
                        break;
                    case 'go':
                        busStops = this.busStopsToThere[passengerId];
                        break;
                    case 'return':
                        busStops = this.busStopsFromThere[passengerId];
                        break;
                }

                var busStopId = this.getBusStopIdByLabel(busStops, stopLabel);
                var priceOfTrip = this.getPriceOfStopByLabel(busStops, stopLabel);

                this.populateArray(this.busTripPrice, passengerId, busGroup, priceOfTrip);
                this.populateArray(this.showPriceOfBusTrip, passengerId, busGroup, true);
                this.populateArray(this.animatePrice, passengerId, busGroup, true);
                this.$timeout(function () {
                    _this9.animatePrice[0][passengerId][busGroup] = false;
                }, 2000);
                this.updatePricesByPassengAssignments(passengerId, busStopId, busGroup, priceOfTrip);
            } else {
                this.productLines = _.filter(this.productLines, function (productLine) {
                    return productLine.PassengerId !== passengerId && productLine.Product.BusStops || !productLine.Product.BusStops;
                });
                this.data.Products = _.filter(this.data.Products, function (productLine) {
                    return productLine.PassengerId !== passengerId && productLine.Product.BusStops || !productLine.Product.BusStops;
                });
                //this.removeBusStopFromProductLines(passengerId, busGroup);
            }
        }
    }, {
        key: 'populateArray',
        value: function populateArray(inputArr, passengerId, busGroup, value) {
            if (inputArr.length > 0) {
                if (inputArr[0][passengerId] != undefined) {
                    if (inputArr[0][passengerId][busGroup] != undefined) {
                        inputArr[0][passengerId][busGroup] = value;
                    } else {
                        inputArr[0][passengerId] = _.merge(inputArr[0][passengerId], _defineProperty({}, busGroup, value));
                    }
                } else {
                    inputArr[0][passengerId] = _defineProperty({}, busGroup, value);
                }
            } else {
                inputArr.push(_defineProperty({}, passengerId, _defineProperty({}, busGroup, value)));
            }
            return inputArr;
        }
    }, {
        key: 'chooseStopToThere',
        value: function chooseStopToThere() {
            var busTripId = this.getTripIdByLabel(this.busGroups.go, this.$scope.busTripToThere);
            var busStopId = this.getBusStopIdByLabel(this.busStopsToThere, this.$scope.busStopToThere);
            this.productService.chooseBusTrip("go", busTripId, busStopId);
        }
    }, {
        key: 'chooseStopFromThere',
        value: function chooseStopFromThere() {
            var busTripId = this.getTripIdByLabel(this.busGroups.return, this.$scope.busTripFromThere);
            var busStopId = this.getBusStopIdByLabel(this.busStopsFromThere, this.$scope.busStopFromThere);
            this.productService.chooseBusTrip("return", busTripId, busStopId);
        }
    }, {
        key: 'getPriceOfStopByLabel',
        value: function getPriceOfStopByLabel(busStops, label) {
            var price = -1;
            busStops.forEach(function (elem, ind) {
                if (elem.Name == label) {
                    price = elem.realPrice;
                }
            });
            return price;
        }
    }, {
        key: 'getBusStopIdByLabel',
        value: function getBusStopIdByLabel(busStops, label) {
            return this.getIdByLabel(busStops, label);
        }
    }, {
        key: 'getTripIdByLabel',
        value: function getTripIdByLabel(busGroup, label) {
            return this.getIdByLabel(busGroup, label);
        }
    }, {
        key: 'getIdByLabel',
        value: function getIdByLabel(list, label) {
            var tempVar = -1;
            list.forEach(function (elem, ind) {
                if (elem.label === label) {
                    tempVar = elem.id;
                }
            });
            return tempVar;
        }
    }, {
        key: 'getIdByLabelArr',
        value: function getIdByLabelArr(list, label) {
            var tempVar = [];
            list.forEach(function (elem, ind) {
                if (elem.label === label) {
                    tempVar.push(elem.id);
                }
            });
            return tempVar;
        }
    }, {
        key: 'chooseRouteToThereAndBackFromBusGroup',
        value: function chooseRouteToThereAndBackFromBusGroup(label, passengerId, busGroup) {
            var _this10 = this;

            if (label === null) {
                this.data.Products.forEach(function (elem, ind) {
                    if (elem.PassengerId != undefined && elem.PassengerId === passengerId) {
                        _this10.data.Products.splice(ind, 1);
                    }
                });
                this.productLines.forEach(function (elem, ind) {
                    if (elem.PassengerId != undefined && elem.PassengerId === passengerId) {
                        _this10.productLines.splice(ind, 1);
                    }
                });
            } else {
                this.getBusStopsFromBusGroupByLabel(this.busGroups[busGroup], label).then(function (response) {
                    _this10.convertBusStops(response, busGroup).then(function (response) {
                        switch (busGroup) {
                            case 'both':
                                _this10.busStopsBothWays[ind] = response[0];
                                break;
                            case 'go':
                                _this10.busStopsToThere[passengerId] = response[0];
                                break;
                            case 'return':
                                _this10.busStopsFromThere[passengerId] = response[0];
                                break;
                        }
                        document.getElementsByTagName('body')[0].click();
                    });
                });
            }
        }
    }, {
        key: 'chooseRouteToThereFromBusGroup',
        value: function chooseRouteToThereFromBusGroup(label) {
            var _this11 = this;

            this.getBusStopsFromBusGroupByLabel(this.busGroups.go, label).then(function (response) {
                _this11.convertBusStops(response, 'go').then(function (response) {
                    _this11.busStopsToThere = response[0];
                    document.getElementsByTagName('body')[0].click();
                });
            });
        }
    }, {
        key: 'convertBusStops',
        value: function convertBusStops(busStopsArr, type) {
            var _this12 = this;

            // Promise to get the getReservableProducts call
            var promiseOne = new Promise(function (resolve, reject) {

                if (_this12.data.SelectedDeparture === null) {
                    reject("[WRES] convertBusStops: No departure trip set");
                } else {
                    var busStopsArrLen = busStopsArr.length;
                    busStopsArr.forEach(function (elem, ind) {
                        elem.id = elem.Id;

                        var searchCriteria = {
                            DestinationCode: _this12.busGroups[type][0].DestinationCode.replace(/ /g, ""),
                            ProductCode: _this12.busGroups[type][0].ProductCode.replace(/ /g, ""),
                            StartDate: _this12.data.SelectedDeparture.DepartureDate,
                            EndDate: _this12.data.SelectedDeparture.ArrivalDate2,
                            PriceGroup: elem.PriceGroup
                        };

                        _this12.productService.getReservableProducts(searchCriteria, _this12.localizationService.getLanguage()).then(function (response) {
                            if (response.length === 0) {
                                console.error("[WRES] convertBusStops: getReservableProducts call is empty");
                                reject('[WRES] convertBusStops: getReservableProducts call is empty');
                            } else {
                                if (response[0].LinkingInfo === null) {
                                    _this12.busProduct = response[1];
                                } else {
                                    _this12.busProduct = response[0];
                                }

                                try {
                                    if (_this12.busProduct.LinkingInfo.ForcingMode === "Forced" && _this12.busProduct.DestinationInfo.ProductType === 'BU') {
                                        _this12.busStopForced = true;
                                    }
                                } catch (err) {
                                    console.error("[WRES] convertBusStops:", err);
                                    _this12.$rootScope.busError = true;
                                }

                                response.forEach(function (pElem) {
                                    if (pElem.ReservablePrices != null && pElem.ReservablePrices.length > 0) {
                                        pElem.ReservablePrices.forEach(function (priceElem, priceInd) {
                                            if (parseInt(elem.K1PriceIndex, 10) === parseInt(priceElem.Index, 10)) {
                                                elem.realPrice = priceElem.Price;
                                                elem.name = elem.Name + ' | Pysäkillä: [ ' + elem.Time + ' ]' + ' | Hinta: [ ' + elem.realPrice + '€ ]';
                                                elem.label = elem.Name;

                                                if (ind == busStopsArrLen - 1) {
                                                    resolve('ok'); //*
                                                }
                                            }
                                        });
                                    } else {
                                        //console.trace();
                                        console.warn("[WRES] convertBusStops: ReservablePrices is empty");
                                        elem.name = elem.Name;
                                        elem.label = elem.Name;
                                        reject('[WRES] convertBusStops: ReservablePrices is empty');
                                    }
                                });

                                /*if(ind == (busStopsArrLen-1)) {
                                    resolve('ok'); //*
                                }*/
                            }
                        }, function (err) {
                            console.log('======= Error ========');
                            console.error(err);
                            console.log('======= Error ========');
                        });
                    });
                }
            });
            return Promise.all([busStopsArr, promiseOne]);
        }
    }, {
        key: 'chooseRouteToThere',
        value: function chooseRouteToThere() {
            var _this13 = this;

            this.getBusStopsByLabel(this.$scope.busTripToThere).then(function (response) {
                _this13.busStopsToThere = response;
                document.getElementsByTagName('body')[0].click();
            });
        }
    }, {
        key: 'chooseRouteFromThereFromBusGroup',
        value: function chooseRouteFromThereFromBusGroup() {
            var _this14 = this;

            this.getBusStopsFromBusGroupByLabel(this.busGroups.return, this.$scope.busTripFromThere).then(function (response) {
                _this14.convertBusStops(response, 'return').then(function (response) {
                    _this14.busStopsFromThere = response[0];
                    document.getElementsByTagName('body')[0].click();
                }).catch(function (err) {
                    console.log(err);
                });
            });
        }
    }, {
        key: 'chooseRouteFromThere',
        value: function chooseRouteFromThere() {
            var _this15 = this;

            this.getBusStopsByLabel(this.$scope.busTripFromThere).then(function (response) {
                _this15.busStopsFromThere = response;
                document.getElementsByTagName('body')[0].click();
            });
        }
    }, {
        key: 'getBusStopsFromBusGroupByLabel',
        value: function getBusStopsFromBusGroupByLabel(busGroup, routeLabel) {
            var tempArr = [];
            busGroup.forEach(function (elem, ind) {
                if (elem.name === routeLabel) {
                    tempArr = elem.BusStops;
                }
            });
            return Promise.all(tempArr);
        }
    }, {
        key: 'getBusStopsByLabel',
        value: function getBusStopsByLabel(routeLabel) {
            var tempArr = [];
            this.busProducts.forEach(function (elem, ind) {
                if (elem.label === routeLabel) {
                    tempArr = elem.busStops;
                }
            });
            return Promise.all(tempArr);
        }
    }, {
        key: 'getReservableBusProducts',
        value: function getReservableBusProducts() {
            var lang = this.localizationService.getLanguage();
            var minCapacity = this.data.NumAdults + this.data.NumChildren;
            var searchCriteria = {
                DestinationCode: this.data.SelectedDeparture.DestinationCode,
                StartDate: this.data.SelectedDeparture.DepartureDate,
                EndDate: this.data.SelectedDeparture.ArrivalDate2,
                MinCapacity: minCapacity,
                ProductType: 'bus'
            };
            var capacityAvailable = this.data.SelectedDeparture.CapacityAvailable;
            return this.productService.getReservableProducts(searchCriteria, lang).then(function (response) {
                console.log("Reservable bus products with MinCapacity " + minCapacity + " are: ", response);
                if (response.length === 0 && capacityAvailable > 0) {
                    console.warn("No bus products received, even though departure has capacity left! Check that everything is okay. this.data: ");
                }
                return response;
            }).catch(function (err) {
                console.log("Error when retrieving reservable bus products with MinCapacity (Adults + Children) " + minCapacity + ": ,", err);
                return null;
            });
        }

        // GetBusRoutes return all routes, so we have to filter out those that are not bookable
        // reservableBusProducts we get by simpy by querying getReservableProducts with productype 'bus' and correct parameters

    }, {
        key: 'filterReservableBusRoutes',
        value: function filterReservableBusRoutes(busroutes) {
            return this.getReservableBusProducts().then(function (reservableBusProducts) {
                console.log("Filtering reservable bus routes...");
                console.log("reservableBusProducts are: ", reservableBusProducts);
                console.log("all busroutes are: ", busroutes);
                return _.filter(busroutes, function (route) {
                    return _.some(reservableBusProducts, function (prod) {
                        if (prod.DestinationInfo.ProductCode === route.ProductCode && prod.DestinationInfo.DestinationCode === route.DestinationCode) {
                            console.log("Route " + route.Route + "has a matching reservable product!");
                            return true;
                        }
                    });
                });
            });
        }
    }, {
        key: 'getAllowedAmounts',
        value: function getAllowedAmounts(product) {
            var numPassengers = this.data.NumAdults + this.data.NumChildren + this.data.NumInfants;
            var min = 0;
            if (product.LinkingInfo.GroupID == 0) {
                if (product.LinkingInfo.ForcingMode == 'Forced') {
                    min = product.LinkingInfo.Minimum * numPassengers;
                }
            }
            var a = [];
            for (var i = 0; i <= numPassengers * Math.max(1, product.LinkingInfo.Maximum); i++) {
                a.push(i);
            }
            return a;
        }

        //demohax remove later

    }, {
        key: 'getAllowedAmountsOmaloma',
        value: function getAllowedAmountsOmaloma(product) {
            var numPassengers = this.data.data.Passengers.length;
            var min = 0;
            var a = [];
            for (var i = 0; i <= numPassengers; i++) {
                a.push(i);
            }
            return a;
        }
    }, {
        key: 'extraServiceAmountChange',
        value: function extraServiceAmountChange(product) {
            //this is a stupid hax which only adds to the invoice, cant remove price
            this.winresReservationContext.addExtraServiceToPassenger(product, 0, 1, "", ""); //product, passengerIndex, num, comment1, comment2
            /*var productLine = this.winresReservationContext.findOrCreateProductLineByProduct(product);
            var priceSelection = this.findOrCreatePriceSelection(priceIndex, productLine);
              priceSelection.Amount = priceSelection.Amount + 1;
            productLine.Product.Amount = productLine.Product.Amount + 1;
            this.calculateTotalPrice(productLine);*/
        }
    }, {
        key: 'reserveExtraServices',
        value: function reserveExtraServices() {
            //for omaloma
            //console.log("reservationExtraServices", this.winresReservationContext.getContext());
            /*    var products = [];
                _.each(this.winresReservationContext.getContext().Products, (s) => {
                    _.each(s, (service) =>{
                        products.push(service);
                    });
                });
                */
            // Calculate per-passenger prices (backend handles this.)
            // Make a product line for each product / passenger -combo
            // (for extra services, the whole product row price is the sum of all
            //  individual passengers' prices. This does not hold for
            //  accommodations.)
            //var products = _.flatten(_.map(this.data.ProductGroups, group => group.Products));
            //console.log(products, this.winresReservationContext.getContext().Products, this.winresReservationContext.context.Products);
            var productLines = this.winresReservationContext.context.Products;
            /*var productLines = _.flatMap(products, product => {
                product.PassengerPrices = [];
                var result = [];
                for (var i = 0; i < this.data.data.Passengers.length; ++i) {
                    result.push({
                        Amount: 1,
                        Product: product,
                        PassengerAssignments: [{
                            ProductNumber: 1,
                            PassengerNumber: i,
                        }],
                    });
                }
                return result;
            });*/

            /*this.reservationService.calculateProductLinePrices(
                this.data,
                productLines,
                this.localizationService.getLanguage()).then(results => {
                    _.zipWith(productLines, results, (productLine, result) => {
                        productLine.Product.PassengerPrices.push(result);
                    });
                });*/
            console.log('PRODUCTS ARE', productLines);

            //this.customerService.TestBookExtraServices(this.data.data.WebCustomer.CustomerID, this.data.BookingNumber, products);

            productLines = _.filter(productLines, function (p) {
                return p.Amount > 0;
            });

            this.customerService.BookCustomerExtraServices(this.data.data.WebCustomer.CustomerID, this.data.BookingNumber, productLines).then(function (result) {
                if (result == null) {
                    alert("Lisäpalvelujen lisääminen varaukselle epäonnistui.");
                } else {
                    alert("Lisäpalvelut lisätty varaukselle.");
                }
            });
        }
    }, {
        key: 'findServiceAmount',
        value: function findServiceAmount(service) {
            var amount = 0;
            _.each(this.data.Products, function (p) {
                if (service.StartDate == p.Product.StartDate && service.EndDate == p.Product.EndDate && service.DestinationInfo.ProductCode == p.Product.DestinationInfo.ProductCode && service.DestinationInfo.DestinationCode == p.Product.DestinationInfo.DestinationCode) {
                    amount = p.Amount;
                }
            });
            return amount;
        }
    }, {
        key: 'extraServiceDateChange',
        value: function extraServiceDateChange() {
            var _this16 = this;

            this.productService.getReservableProductsGrouped({
                DestinationCode: this.data.Destination.DestinationCode,
                StartDate: this.data.DefaultStartDate,
                EndDate: this.data.DefaultEndDate,
                MinCapacity: 1,
                GroupIDs: null,
                ProductType: 'common'
            }, this.localizationService.getLanguage()).then(function (productGroups) {
                return _this16.productsEdit(productGroups);
            });
        }
    }, {
        key: 'tryResetSessionProductGroups',
        value: function tryResetSessionProductGroups() {
            var hasSession = this.data.ProductGroups != null && this.data.ProductGroups.length > 0
            //&& this.data.ProductGroups[0].Products[0].DestinationInfo.DestinationCode==this.data.DestinationCode // Clear product group session if different destination.
            && this.data.SelectedDeparture && this.data.ProductGroups[0].Products[0].BeginDate == moment(this.data.SelectedDeparture.DepartureDate).format("YYYY-MM-DD") && this.data.SelectedDeparture && this.data.ProductGroups[0].Products[0].EndDate == moment(this.data.SelectedDeparture.ArrivalDate2).format("YYYY-MM-DD");

            if (!hasSession) this.data.ProductGroups = [];

            return hasSession;
        }
    }, {
        key: 'productsEdit',
        value: function productsEdit(productGroups) {
            var _this17 = this;

            _.each(this.data.Products, function (p) {
                if (!p.Amount) {
                    p.Amount = 0;
                }
            });

            var hasSessionProductGroups = this.tryResetSessionProductGroups();

            // Get product groups from session.
            if (hasSessionProductGroups) productGroups = this.data.ProductGroups;

            _.each(productGroups, function (group, index) {
                // The result is an array, if groups 0 and 2 are set,
                // 1 might be undefined (since arrays are not sparse
                // in Javascript)
                if (!group || group.length == 0) {
                    return;
                }

                if (!hasSessionProductGroups) {
                    var object = {
                        Unpicked: _this17.data.NumAdults,
                        PickedTooMany: 0,
                        Products: group,
                        Index: index,
                        Min: group[0].LinkingInfo ? group[0].LinkingInfo.Minimum : 1,
                        Max: group[0].LinkingInfo ? group[0].LinkingInfo.Maximum : 1
                    };

                    if (object.Min == null || object.Min <= 0) {
                        if (group[0].LinkingInfo.ForcingMode == 'Forced'
                        /*&& group[0].LinkingInfo.Type !== 'Normal'*/) {
                                object.Min = 1;
                            } else {
                            object.Min = 0;
                        }
                    }

                    if (object.Max == null || object.Max <= 0) {
                        object.Max = 1;
                    }
                    _this17.data.ProductGroups.push(object);
                }

                // Convert group to group of products if session.
                if (hasSessionProductGroups) group = group.Products;

                _.each(group, function (product) {
                    if (!product.Amount) {
                        product.Amount = _this17.findServiceAmount(product);
                    }
                    if (_this17.assignPassengers == "false") {
                        _this17.$scope.$watch(function () {
                            return product.Amount;
                        }, function (num) {
                            var productLine = _this17.winresReservationContext.findProductLineByProduct(product);
                            if (!productLine) {
                                productLine = {
                                    Amount: num,
                                    Product: product,
                                    PassengerAssignments: []
                                };
                                _this17.data.Products.push(productLine);
                            }
                            productLine.Amount = num;
                            productLine.UnitProce = product.Price;
                            productLine.TotalPrice = productLine.Amount * product.Price;

                            _this17.validate();
                        });
                    } else {
                        if (!product.PassengerCounts) product.PassengerCounts = [];

                        var productLine = _this17.winresReservationContext.findProductLineByProduct(product);
                        if (productLine) {
                            _this17.$scope.$watch(function () {
                                return productLine.PassengerAssignments;
                            }, function () {
                                return _this17.updateAmounts(productLine);
                            }, true);
                        }
                        _this17.$scope.$watch(function () {
                            return product.PassengerCounts;
                        }, function () {
                            _this17.updateAssignments(product);
                            _this17.updateProductPrice(product);
                            _this17.validate();
                        }, true);
                    }
                });
            });

            console.log("product groups ", this.data.ProductGroups);

            this.updatePassengerPrices();

            //if(this.noForcingsIfActivity === 'true' && this.products[0].DestinationInfo.ProductType != 'MÖ' && this.products[0].DestinationInfo.ProductType != 'HU' && this.products[0].DestinationInfo.ProductType != 'HY'){
            if (this.noForcingsIfActivity === 'true' && this.data.Products[0] && this.data.Products[0].DestinationInfo.ProductType != 'MÖ' && this.data.Products[0].DestinationInfo.ProductType != 'HU' && this.data.Products[0].DestinationInfo.ProductType != 'HY') {} else {
                this.updateNonGroupForcings();
            }
        }
    }, {
        key: 'extraServicePerPassengerAmountChange',
        value: function extraServicePerPassengerAmountChange(product, passengerIndex) {
            var productLine = this.winresReservationContext.findOrCreateProductLineByProduct(product);
            var newAmount = 0;
            if (product.PassengerCounts && product.PassengerCounts[passengerIndex] > -1) {
                newAmount = product.PassengerCounts[passengerIndex]; //newAmount should now be 0 or 1
            }
            console.log('newAmount on nyt', newAmount);
            if (newAmount === 0) {
                //remove assignment
                console.log('productLine.PassengerAssignments on nyt', productLine.PassengerAssignments);
                //productLine.PassengerAssignments = _.filter(productLine.PassengerAssignments, { 'PassengerNumber': passengerIndex });
                productLine.PassengerAssignments = _.filter(productLine.PassengerAssignments, function (o) {
                    return o.PassengerNumber != passengerIndex;
                });

                console.log('productLine.PassengerAssignments on nyt', productLine.PassengerAssignments);
            }
            if (newAmount === 1 && _.find(productLine.PassengerAssignments, function (sel) {
                return sel.PassengerNumber == passengerIndex;
            }) === undefined) {
                console.log('productLine.PassengerAssignments on nyt', productLine.PassengerAssignments);
                this.winresReservationContext.addExtraServiceToPassenger(product, passengerIndex, 1, "", ""); //product, passengerIndex, num, comment1, comment2
                productLines.Amount = productLines.Amount + 1;
                console.log('productLine.PassengerAssignments on nyt', productLine.PassengerAssignments);
            }
            productLine.Amount = productLine.PassengerAssignments.length;

            var passengerAssignment = _.find(productLine.PassengerAssignments, function (sel) {
                return sel.PassengerNumber == passengerIndex;
            });
        }
    }, {
        key: 'priceSelectionsSumByProductLineByProduct',
        value: function priceSelectionsSumByProductLineByProduct(product) {
            var sum = 0;
            var productLine = this.winresReservationContext.findOrCreateProductLineByProduct(product);
            if (productLine.PriceSelections) {
                for (var i = 0; i < productLine.PriceSelections.length; i++) {
                    sum = sum + productLine.PriceSelections[i].Amount;
                }
            }
            return sum;
        }

        // this is the max amout of one item per order function. idk does this work but specifications changed in the middle of working...

    }, {
        key: 'checkProductAmount',
        value: function checkProductAmount(passengerIndex) {
            /*var isFull = false;
            _.each(this.data.ProductGroups, group => {
                _.each(group.Products, product => {
                      if(this.limitProductCode != null && product.LinkingInfo.ProductCode == this.limitProductCode){
                        var pplAmount = 0;
                        var passengerHasItem = false;
                        _.each(product.PassengerCounts, function(count, index){
                            pplAmount += count;
                            if(passengerIndex == index){
                                passengerHasItem = true;
                            }
                        });
                        if(pplAmount >= this.limitProductAmount && !passengerHasItem){
                            console.log('wörk');
                            isFull = true;
                            return false;
                        }
                    }
                });
            });
            if(!isFull){
                return true;
            }*/

            return true;
        }

        //this function simply calls addProducts function to set preselected amount.

    }, {
        key: 'setNewProductAmount',
        value: function setNewProductAmount(product, priceIndex, amount) {
            for (var i = 0; i < amount; i++) {
                this.addProduct(product, priceIndex);
            }
        }
    }, {
        key: 'addProduct',
        value: function addProduct(product, priceIndex) {
            try {
                var resContext = this.winresReservationContext;
                var productLine = resContext.findOrCreateProductLineByProduct(product);
                var priceSelection = this.findOrCreatePriceSelection(priceIndex, productLine);
                productLine.Amount += 1;
                priceSelection.Amount = priceSelection.Amount + 1;
                productLine.Product.Amount = productLine.Product.Amount + 1;
                resContext.calculateTotalPrice(productLine);
            } catch (e) {
                console.error(e);
            }
        }
    }, {
        key: 'setProductPriceAmount',
        value: function setProductPriceAmount(product, priceIndex, amount) {
            try {
                var resContext = this.winresReservationContext;
                var productLine = resContext.findOrCreateProductLineByProduct(product);
                var priceSelection = this.findOrCreatePriceSelection(priceIndex, productLine);
                productLine.Amount = amount;
                priceSelection.Amount = amount;
                productLine.Product.Amount = amount;
                resContext.calculateTotalPrice(productLine);
            } catch (e) {
                console.error(e);
            }
        }
    }, {
        key: 'reduceProduct',
        value: function reduceProduct(product, priceIndex) {
            var productLine = this.winresReservationContext.findOrCreateProductLineByProduct(product);
            var priceSelection = this.findOrCreatePriceSelection(priceIndex, productLine);
            productLine.Amount -= 1;
            priceSelection.Amount = priceSelection.Amount - 1;
            productLine.Product.Amount = productLine.Product.Amount - 1;
            this.winresReservationContext.calculateTotalPrice(productLine);
        }
    }, {
        key: 'findOrCreatePriceSelection',
        value: function findOrCreatePriceSelection(priceIndex, productLine) {
            //if(!productLine.PriceSelections) return null;
            var priceSelection = _.find(productLine.PriceSelections, function (sel) {
                return sel.PriceIndex == priceIndex;
            });
            if (priceSelection === undefined) {
                var priceSelection = {
                    PriceIndex: priceIndex,
                    Amount: 1 // Was 0.
                };
                if (!productLine.PriceSelections) {
                    productLine.PriceSelections = [];
                }
                productLine.PriceSelections.push(priceSelection);
            }
            return priceSelection;
        }
    }, {
        key: 'getFlatProducts',
        value: function getFlatProducts() {
            return _.flatten(_.map(this.data.ProductGroups, function (group) {
                return group.Products;
            }));
        }
    }, {
        key: 'updatePassengerData',
        value: function updatePassengerData() {
            this.updatePassengerNames();
            this.updatePassengerPrices();
        }
    }, {
        key: 'updatePassengerNames',
        value: function updatePassengerNames() {
            this.PassengerNames = this.winresReservationContext.getPassengerDisplayNames();
        }

        // Updates the user-visible price in the product.

    }, {
        key: 'updateProductPrice',
        value: function updateProductPrice(product) {
            console.log("Updating product price...");
            product.SelectedPrice = null;

            var productLine = this.winresReservationContext.findProductLineByProduct(product);

            if (productLine) {
                // Just throw the whole product line to the backend.
                this.reservationService.calculateProductLinePrice(this.data, productLine, this.localizationService.getLanguage()).then(function (result) {
                    if (result) {
                        product.SelectedPrice = productLine.TotalPrice = result.Price;
                        productLine.UnitPrice = result.UnitPrice;
                    } else {
                        product.SelectedPrice = 0;
                        productLine.TotalPrice = 0;
                        productLine.UnitPrice = 0;
                    }
                });
            }
        }
    }, {
        key: 'updatePassengerPrices',
        value: function updatePassengerPrices() {
            var _this18 = this;

            // Calculate per-passenger prices (backend handles this.)
            // Make a product line for each product / passenger -combo
            // (for extra services, the whole product row price is the sum of all
            //  individual passengers' prices. This does not hold for
            //  accommodations.)
            var products = this.getFlatProducts();

            var productLines = _.flatMap(products, function (product) {
                var result = [];
                for (var i = 0; i < _this18.data.Passengers.length; ++i) {
                    result.push({
                        Amount: 1,
                        Product: product,
                        PassengerAssignments: [{
                            ProductNumber: 1,
                            PassengerNumber: i
                        }]
                    });
                }
                return result;
            });

            // Triggers request each time passenger info changes.
            //_.each(products, product => {
            //    product.PassengerPrices = [];
            //});

            // Passenger info changed CalculateProductLinePrices request 1.
            this.reservationService.calculateProductLinePrices(this.data, productLines, this.localizationService.getLanguage()).then(function (results) {
                _.each(products, function (product) {
                    product.PassengerPrices = []; // Moved here.
                });
                _.zipWith(productLines, results, function (productLine, result) {
                    productLine.Product.PassengerPrices.push(result);
                });
            });
            //console.log('PRODUCTS ARE', products);
        }
    }, {
        key: 'validate',
        value: function validate() {
            var _this19 = this;

            // Forced and hidden products are auto-selected, so validate only group
            // forcings.
            var errors = [];
            _.each(this.data.ProductGroups, function (group) {
                if ( /* is group forcing? */group.Index > 0) {
                    // Validate by count only
                    var groupTitle = _this19['groupTitle' + group.Index];
                    if (!groupTitle || _.trim(groupTitle) == '') {
                        groupTitle = group.Index;
                    }

                    if (_this19.assignPassengers != 'false') {
                        // Check that each passenger has the right amount
                        var numPassengers = _this19.data.NumAdults + _this19.data.NumChildren + _this19.data.NumInfants;
                        for (var i = 0; i < numPassengers; ++i) {
                            var numSelected = 0;
                            _.each(group.Products, function (product) {
                                var productLine = _this19.winresReservationContext.findProductLineByProduct(product);
                                if (!productLine || !productLine.PassengerAssignments) {
                                    return;
                                }
                                var assignments = _.filter(productLine.PassengerAssignments, function (assignment) {
                                    return assignment.PassengerNumber == i;
                                });

                                numSelected += assignments.length;
                            });

                            var errorParams = {
                                group: groupTitle,
                                passenger: _this19.PassengerNames[i],
                                min: group.Min,
                                max: group.Max
                            };

                            if (numSelected < group.Min) {
                                errors.push({
                                    Message: 'reservation_extra_services.error_too_few_passenger' + (group.Min == 1 ? '_singular' : ''),
                                    Params: errorParams
                                });
                            }

                            if (numSelected > group.Max) {
                                errors.push({
                                    Message: 'reservation_extra_services.error_too_many_passenger' + (group.Max == 1 ? '_singular' : ''),
                                    Params: errorParams
                                });
                            }
                        }
                    } else {
                        if (group.Unpicked > 0) {
                            errors.push({
                                Message: 'reservation_extra_services.error_too_few' + (group.Min == 1 ? '_singular' : ''),
                                Params: {
                                    group: groupTitle,
                                    num: group.Min
                                }
                            });
                        }

                        if (group.PickedTooMany > 0) {
                            errors.push({
                                Message: 'reservation_extra_services.error_too_many' + (group.Max == 1 ? '_singular' : ''),
                                Params: {
                                    group: groupTitle,
                                    num: group.Max
                                }
                            });
                        }
                    }
                }
            });

            this.winresReservationContext.setReservationComponentErrors(this.phase, '', errors);
        }
    }, {
        key: 'updateAmounts',
        value: function updateAmounts(productLine) {
            var product = this.findProduct(productLine);
            if (!product) {
                // Products have not been loaded yet.
                return;
            }

            var numPassengers = this.data.NumAdults + this.data.NumChildren + this.data.NumInfants;
            // Avoid replacing passengerCounts, since otherwise this might end
            // in an infinite digest loop. Also, $watch would stop working since
            // it watches the array object.

            product.PassengerCounts.length = numPassengers;
            _.fill(product.PassengerCounts, 0);
            _.each(productLine.PassengerAssignments, function (assignment) {
                if (!product.PassengerCounts[assignment.PassengerNumber]) {
                    product.PassengerCounts[assignment.PassengerNumber] = 0;
                }
                product.PassengerCounts[assignment.PassengerNumber]++;
            });

            productLine.Amount = product.Amount = _.sum(product.PassengerCounts);
            if (productLine.Amount == 0) {
                _.pull(this.data.Products, productLine);
            }
        }
    }, {
        key: 'hasForcedProduct',
        value: function hasForcedProduct(p) {
            return _.some(this.forcedProducts, function (product) {
                return p.DestinationInfo.DestinationCode == product.Product.DestinationInfo.DestinationCode && p.DestinationInfo.ProuductCode == product.Product.DestinationInfo.ProuductCode && p.DestinationInfo.ProductName == product.Product.DestinationInfo.ProductName;
            });
        }

        // Creates a passenger assignment row for each checked passenger (if multiple
        // selected, creates multiple passenger assignment rows.)
        // (NOTE: Passenger assignment maps to AsukkLis)

    }, {
        key: 'updateAssignments',
        value: function updateAssignments(product) {
            var _this20 = this;

            var assignments = [];
            var productNumber = 1;
            _.each(product.PassengerCounts, function (count, index) {
                for (var i = 0; i < count; ++i) {
                    assignments.push({
                        PassengerNumber: index,
                        ProductNumber: productNumber++
                    });
                }
            });

            var productLine = this.winresReservationContext.findProductLineByProduct(product);

            // this.hasForcedProducts is a temporary solution to clear duplicate forced products for every second destination.
            if (assignments.length > 0 && !productLine && !this.hasForcedProduct(product)) {
                // Create product line
                productLine = {
                    Product: product,
                    Amount: assignments.length,
                    PassengerAssignments: assignments
                    //TotalPrice: parseInt(product.Price)
                };
                //this.checkForForcedProducts();

                // Create price selection.
                //if(product.DestinationInfo.ProductType!='MU'){
                if (product.LinkingInfo && product.LinkingInfo.ForcingMode === 'Forced' && product.LinkingInfo.Type !== 'Normal') {
                    if (this.priceSelectionIds == null) this.priceSelectionIds = 1;
                    var priceSelection = this.findOrCreatePriceSelection(this.priceSelectionIds, productLine);
                    priceSelection.Amount = assignments.length;
                    this.priceSelectionIds++;
                }
                this.data.Products.push(productLine);

                this.$scope.$watch(function () {
                    return productLine.PassengerAssignments;
                }, function () {
                    return _this20.updateAmounts(productLine);
                });
            } else if (assignments.length == 0 && productLine) {
                _.pull(this.data.Products, productLine);
            } else if (productLine) {
                // Do not replace PassengerAssignments because $watches would stop
                // working. This hack copies the array without replacing the
                // original.

                productLine.PassengerAssignments.length = 0;
                productLine.PassengerAssignments.push.apply(productLine.PassengerAssignments, assignments);
                productLine.Amount = assignments.length;
            }

            // Update this since it is displayed in the GUI.
            product.Amount = assignments.length;
        }
    }, {
        key: 'findProduct',
        value: function findProduct(productLine) {
            // NOTE: Cannot just return productLine.Product - it needs to be the
            // same object instance that is loaded fro backend. If the page is
            // reloaded, the data in session might be used, which would be
            // JSON-decoded and have a different object instalce for Product.
            var result = null;
            _.each(this.data.ProductGroups, function (group) {
                _.each(group.Products, function (product) {
                    if (product.StartDate == productLine.Product.StartDate && product.EndDate == productLine.Product.EndDate && product.DestinationInfo.ProductCode == productLine.Product.DestinationInfo.ProductCode && product.DestinationInfo.DestinationCode == productLine.Product.DestinationInfo.DestinationCode) {
                        result = product;
                    }
                });
            });
            return result;
        }

        // Updates forced linkings and key products (that are not group forcings).
        // I.e. when the user cannot select them for passengers, they must be
        // selected programmatically. (pakotus)

    }, {
        key: 'updateNonGroupForcings',
        value: function updateNonGroupForcings() {
            var _this21 = this;

            if (!this.data.ProductGroups) {
                return;
            }

            this.tryResetSessionProductGroups();

            var group = _.find(this.data.ProductGroups, function (g) {
                return g.Index == 0;
            });
            if (!group) {
                return;
            }
            _.each(group.Products, function (product) {
                if (!product.LinkingInfo // Key product (INT_KAYTTO=1)
                || product.LinkingInfo.ForcingMode == 'Forced') {
                    var numPassengers = _this21.data.NumAdults + _this21.data.NumChildren;

                    // Normal forcing, not group forcing. The product MUST be selected
                    // for each passenger between min and max. Ensure that the minimum
                    // is selected.
                    var productLine = _this21.winresReservationContext.findProductLineByProduct(product);

                    // Key products are treated as for-each-passenger products.
                    // They have no linking info, since they're not linked in the first place.
                    var isForEachPassenger = !product.LinkingInfo || product.LinkingInfo.IsForEachPassenger;

                    var prodLineAmount = isForEachPassenger ? group.Min * numPassengers : group.Min;

                    if (!productLine && group.Min > 0 && numPassengers > 0) {
                        productLine = {
                            Amount: prodLineAmount,
                            Product: product,
                            PassengerAssignments: []
                        };

                        // Add forced product for checking duplicates.
                        _this21.forcedProducts.push(productLine);

                        _this21.data.Products.push(productLine);

                        _this21.$scope.$watch(function () {
                            return productLine.PassengerAssignments;
                        }, function () {
                            return _this21.updateAmounts(productLine);
                        });
                    }

                    if (productLine) {
                        // Check that each passenger has at least the
                        // minimum selected.

                        var eachPassenger = !product.LinkingInfo || product.LinkingInfo.IsForEachPassenger;
                        var iterationLength = eachPassenger ? numPassengers : 1;
                        for (var i = 0; i < iterationLength; ++i) {
                            var assignments = _.filter(productLine.PassengerAssignments, function (assignment) {
                                return assignment.PassengerNumber == i;
                            });

                            for (var j = 0; j < group.Min - assignments.length; ++j) {
                                productLine.PassengerAssignments.push({
                                    PassengerNumber: i
                                    // Product number will be added later
                                });
                            }
                        }

                        //Renumber assignment productnumbers
                        _.each(productLine.PassengerAssignments, function (assignment, index) {
                            assignment.ProductNumber = index + 1;
                        });

                        if (eachPassenger) {
                            _this21.updateAmounts(productLine);
                        } else {
                            var priceIndex = product.ReservablePrices["0"].Index; // Pick the first one of the prices
                            var amount = 1;
                            _this21.setProductPriceAmount(product, priceIndex, amount);
                        }
                    }
                }
            });
        }

        // This function is not used at the time of writing this comment

    }, {
        key: 'checkForForcedProducts',
        value: function checkForForcedProducts() {
            var _this22 = this;

            console.log("[WRES] Checking if forced products exist among products");
            var result = null;
            _.each(this.data.ProductGroups, function (group) {
                console.log("Checking group: ", group);
                _.each(group.Products, function (product) {
                    console.log("Checking product: ", product.DestinationInfo.ProductName);
                    if (product.LinkingInfo && product.LinkingInfo.ForcingMode == 'Forced') {
                        if (product.LinkingInfo.IsForEachPassenger) {
                            console.log("This product is forced for each passenger");
                            var numPassengers = _this22.data.NumAdults + _this22.data.NumChildren + _this22.data.NumInfants;
                            var priceIndex = product.ReservablePrices["0"].Index; // Pick the first one of the prices

                            var amount = numPassengers;
                            _this22.setNewProductAmount(product, priceIndex, amount);
                        } else {
                            console.log("[WRES] Product is forced: " + product.DestinationInfo.ProductName);
                            var priceIndex = product.ReservablePrices["0"].Index; // Pick the first one of the prices
                            var amount = 1;
                            _this22.setNewProductAmount(product, priceIndex, amount);
                        }
                    }
                });
            });
        }
    }]);

    return WinresReservationExtraServicesController;
}();

WinresReservationExtraServicesController.$inject = ['$scope', 'productService', 'reservationService', 'localizationService', 'customerService', '$location', '$rootScope', '$timeout'];

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils.getWebcomponentsUrl)($attrs.templateUrl)) : 'reservationExtraServices';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('reservationExtraServices', require('./winresReservationExtraServices.html'));
}]);
//
_module3.default.component('winresReservationExtraServices', {
    //template: require('./winresReservationExtraServices.html'),
    templateUrl: getTemplate,
    controller: WinresReservationExtraServicesController,
    require: {
        winresReservationContext: '?^^winresReservationContext'
    },
    bindings: {
        // Parse SelectedDeparture from URL?
        fromUrl: '@',
        // Comma-separated, which linking groups to show. 0 also includes
        // non-linked products (avaintuote)
        groups: '@',
        groupTitle0: '@',
        groupTitle1: '@',
        groupTitle2: '@',
        groupTitle3: '@',
        groupTitle4: '@',
        groupTitle5: '@',
        groupTitle6: '@',
        groupTitle7: '@',
        groupTitle8: '@',
        groupTitle9: '@',
        groupTitle10: '@',
        phase: '@',
        showContinueButton: '@',
        assignPassengers: '@', //Default: 'true'
        showAlways: '@',

        // uses defined destinationcode without dates.
        forceDestCode: '@',

        // gets the destinationcode from selected destination instead of data.
        useSelectedDeparture: '@',

        source: '@', //For determining if omaloma for different info retrieval

        // To limit how many of specific product(s)/service(s) can be ordered per order, code is the 'ProductCode'
        limitProductCode: '@',
        limitProductAmount: '@',

        noForcingsIfActivity: '@',

        hideBusses: '@'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationExtraServices/winresReservationExtraServices.js
// module id = 377
// module chunks = 2